import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import loadable from '@loadable/component';

import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  useURLChangeCallback,
} from '../../utils/hookHelper';

import { forceToArray, sanitizedHTML, isSSOLoggedIn } from '../../utils/Helper';

import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';
import Loader from '../../components/Loader';
import UnderConstruction from '../../components/UnderConstruction';
import PageIntro from '../../components/PageIntro';
import NoMatch from '../NoMatch';
import MemberOnly from '../../components/MemberOnly';

import config from '../../config';

const Links = loadable(() => import('../../widgets/Links'));

const LinksPage = (props) => {
  const {
    match = {},
    i18n,
    linksPage,
    allowCookies,
    enableTealium,
    enableAdGlare,
    siteConfig,
  } = props;
  const debouncePageLoading = useDebounceLoading(linksPage);
  const jsLoading = useDelayJsLoadiing(linksPage);
  const notFound = useNotFound(linksPage);

  usePage(match.params.pageName, config.pageType.linksPage);
  useAdGlare(i18n.locale, siteConfig, linksPage, enableAdGlare.status);
  useUnmountResetPage();

  const { locale } = i18n;
  const { data = {} } = linksPage || {};
  const content = ((data || {}).content || {}).content || {};
  const dataContent = content[locale] || {};
  const { under_construction = false } = content;

  // content
  const headline = dataContent.headline || '';
  const description = dataContent.description || '';
  const links = dataContent.links || '';

  // HelmetMeta
  const { metadata = {} } = data || {};
  const publishDate = metadata['TeamSite/LiveSite/PublishDate'];
  const seo = dataContent.seo || {};
  const { css_style_block = '', js_script_block = '', extra_head = '' } = content;

  const title = seo.seo_title;
  const [domTitle, setDomTitle] = useState('');
  const [isScriptReady, setIsScriptReady] = useState(false);

  useTealium(
    i18n.locale,
    siteConfig,
    linksPage,
    allowCookies.status,
    enableTealium.status,
    domTitle,
  );

  useURLChangeCallback(locale, data, null, [], isScriptReady);

  const helmetTitleCallBack = (newState) => {
    setDomTitle(newState.title);
  };

  const helmetScriptCallBack = (isReady) => {
    setIsScriptReady(isReady);
  };

  const headlineEle = <>{headline && <PageIntro headline={headline} />}</>;

  const headlineDesc = (
    <>{description && <div dangerouslySetInnerHTML={{ __html: sanitizedHTML(description) }} />}</>
  );

  const mainContent = (
    <>
      <Links links={forceToArray(links)} />
    </>
  );

  // make sure SSO is ready
  const memberOnlyInd = metadata.memberOnly === 'true';

  const contentEle =
    memberOnlyInd && !isSSOLoggedIn() ? (
      <MemberOnly />
    ) : (
      <>
        <Container>
          {under_construction && <UnderConstruction />}
          {!under_construction && headlineDesc}
          {!under_construction && mainContent}
        </Container>
        {!under_construction && (
          <HelmetScript
            helmetScriptCallBack={helmetScriptCallBack}
            extraHead={extra_head}
            jsScript={js_script_block}
          />
        )}
      </>
    );

  const pageEle = (
    <div>
      {notFound ? (
        <NoMatch />
      ) : (
        <div>
          {headlineEle}
          {contentEle}
        </div>
      )}
    </div>
  );

  return (
    <>
      {debouncePageLoading || jsLoading ? <Loader /> : pageEle}
      {!debouncePageLoading && <HelmetHead extraHead={extra_head} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={css_style_block} />}
      {!debouncePageLoading && <HelmetTitle title={title} cb={helmetTitleCallBack} />}
      {!debouncePageLoading && <HelmetMeta seo={seo} publishDate={publishDate} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  linksPage: state.generalPage,
  allowCookies: state.allowCookies,
  enableTealium: state.enableTealium,
  enableAdGlare: state.enableAdGlare,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(LinksPage);

export { LinksPage as LinksPageComponent }; // <- For component Unit Test
export default connectStore;
